<template>
	<!-- 系统代码 -->
	<div class="systemCode">
		<div class="systemCodePC pulbic_system_oparetionBlock">
			<div class="systemCodePC-side">
				<div class="systemCodePC-side-nav">
					<div class="systemCodePC-side-nav-item pulic_cursor" @click="typeClick(index)" :class="{systemCodeActive:codeIndex===index}"
					 v-for="(item,index) of typeList" :key="index">
						<i class="el-icon-paperclip"></i>
						<span class="">{{item.SETTB205CA00}}</span>
					</div>
				</div>
			</div>
			<div class="systemCodePC-content">
				<div class="systemCodePC-content-btn public_operatBtn" style="margin-left: 0px;">
					<el-button class="public_saleWater_xinzeng" type="primary" icon="iconfont icon-tianjia1" @click="newlyAdd" v-shiroHiden="solelist" id="新增">新增</el-button>
				</div>
				<!-- 默认 -->
				<div class="systemCodePC-content-table" v-if="codeIndex==-1">
					<div class="systemCodePC-content-table-li public-table-bg">
						<div class="systemCodePC-content-table-li-type">代码类型</div>
						<!-- <div class="systemCodePC-content-table-li-code">代码值</div> -->
						<div class="systemCodePC-content-table-li-text">中文描述</div>
						<div class="systemCodePC-content-table-li-oper">操作</div>
					</div>
					<div class="systemCodePC-content-table-li public-hover public-table-bg" v-for="(item,index) of moList" :key="index">
						<div class="systemCodePC-content-table-li-type">{{item.SETTB205ID}}</div>
						<!-- <div class="systemCodePC-content-table-li-code">{{item.SETTB205CD01}}</div> -->
						<div class="systemCodePC-content-table-li-text">{{item.SETTB205CA00}}</div>
						<div class="systemCodePC-content-table-li-oper">
							<el-button class="public_icon_xiugai public_icon_width" type="primary"  size="small" @click="modify(index)" v-shiroHiden="solelist" id="修改">修改</el-button>
						</div>
					</div>
				</div>
				<!-- 点击类型选择 -->
				<div class="systemCodePC-content-table" v-else>
					<div class="systemCodePC-content-table-li public-table-bg">
						<div class="systemCodePC-content-table-li-type">代码类型</div>
						<div class="systemCodePC-content-table-li-code">代码值</div>
						<div class="systemCodePC-content-table-li-text">中文描述</div>
						<div class="systemCodePC-content-table-li-oper">操作</div>
					</div>
					<div class="systemCodePC-content-table-li public-hover public-table-bg" v-for="(item,index) of leftTypeList" :key="index">
						<div class="systemCodePC-content-table-li-type">{{item.SETTB205ID}}</div>
						<div class="systemCodePC-content-table-li-code">{{item.SETTB206CA00}}</div>
						<div class="systemCodePC-content-table-li-text">{{item.SETTB206CA01}}</div>
						<div class="systemCodePC-content-table-li-oper">
							<el-button type="danger" class="public_icon_jinyong public_icon_width public_icon_margin" size="small" @click="disableClick(index)" v-shiroHiden="solelist" id="禁用" v-if="item.SETTB206CA02==1">禁用</el-button>
							<el-button type="info" class="public_icon_qiyong public_icon_width public_icon_margin"  size="small" @click="disableClick(index)" v-shiroHiden="solelist" id="启用" v-if="item.SETTB206CA02==0">启用</el-button>
							<el-button type="primary" class="public_icon_xiugai public_icon_width"  size="small" v-shiroHiden="solelist" id="修改" @click="modify(index)">修改</el-button>
						</div>
					</div>
				</div>
				<div  style="text-align: center; height: 80px;line-height: 80px; border-bottom: 1px solid #CDCDCD;" v-if="codeIndex==-1" v-show="this.moList.length==0">暂无数据</div>
				<div style="text-align: center; height: 80px;line-height: 80px; border-bottom: 1px solid #CDCDCD;" v-else v-show="this.leftTypeList.length==0">暂无数据</div>
				<div class="systemCodePC-pagesize">
					<el-pagination v-if="codeIndex==-1" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" 
					 :page-sizes="[10, 20, 30, 40]" :page-size="limitMo" layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
					</el-pagination>
					<el-pagination v-else @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
					 :page-sizes="[10, 20, 30, 40]" :page-size="limitLeft" layout="total,sizes, prev, pager, next, jumper" :total="pagingPageLeft">
					</el-pagination>
				</div>
			</div>
			
			<!-- 新增 -->
			<div class="public-dialog">
				<el-dialog title="新增系统代码" @close="XAdd" :visible.sync="systemCodePCAddCode" width="30%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-code-dialog">
					<div class="systemCodePC-add-code">
						<div class="systemCodePC-add-code-table">
							<div class="systemCodePC-add-code-table-li">
								<div class="systemCodePC-add-code-table-li-name">所属类型</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<el-select v-model="value" @change="changAdd" class="systemCode_beloneStyle" placeholder="请选择">
										<el-option v-for="item in typeAddList" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="systemCodePC-add-code-table-li-text"></div>
							</div>
							<div class="systemCodePC-add-code-table-li" v-if="optionOne!='选项1'">
								<div class="systemCodePC-add-code-table-li-name">代码值</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<input type="text" v-model="codeAdd" /><!-- @keyup="moneyUp" -->
								</div>
								<div class="systemCodePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemCodePC-add-code-table-li" v-else>
								<div class="systemCodePC-add-code-table-li-name">代码类型</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<input type="text" v-model="codeTypeAdd" placeholder='推荐:01'/>
								</div>
								<div class="systemCodePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemCodePC-add-code-table-li">
								<div class="systemCodePC-add-code-table-li-name">中文描述</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<input type="text" v-model="chineseAdd" />
								</div>
								<div class="systemCodePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemCodePC-add-code-table-li" v-if="optionOne!='选项1'">
								<div class="systemCodePC-add-code-table-li-name">附加值</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<input type="text" v-model="addedValueAdd"/>
								</div>
								<div class="systemCodePC-add-code-table-li-text"></div>
							</div>
						</div>
						<div class="systemCodePC-add-code-btn">
							<el-button type="warning" @click="cancelAdd">取消</el-button>
							<el-button type="primary" @click="preservationAdd">保存</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<!-- 修改 -->
			<div class="public-dialog">
				<el-dialog title="编辑系统代码" :visible.sync="systemCodePCUpCode" width="30%" :closeOnClickModal="false" append-to-body custom-class="system-settings-system-code-dialog">
					<div class="systemCodePC-add-code">
						<div class="systemCodePC-add-code-table">
							<div class="systemCodePC-add-code-table-li" v-if="codeIndex!=-1">
								<div class="systemCodePC-add-code-table-li-name">所属类型</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<!-- <el-select ref='aa'  v-model="value" @change="selectChange" @focus="elSelect(typeList[codeIndex].value)" placeholder="请选择"> -->
									<el-select v-model="value" class="systemCode_beloneStyle" @change="selectChange" @focus="elSelect" placeholder="请选择">
										<el-option v-for="item in typeAddList" :key="item.value" :label="item.label" :value="item.value" ref='selectHover'>
										</el-option>
									</el-select>
								</div>
								<div class="systemCodePC-add-code-table-li-text"></div>
							</div>
							<div class="systemCodePC-add-code-table-li" v-if="codeIndex==-1">
								<div class="systemCodePC-add-code-table-li-name">代码类型</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<input type="text" v-model="codeTypeValue" readonly />
								</div>
								<div class="systemCodePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemCodePC-add-code-table-li" v-else>
								<div class="systemCodePC-add-code-table-li-name">代码值</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<input type="text" v-model="codeValue" readonly />
								</div>
								<div class="systemCodePC-add-code-table-li-text"></div>
							</div>
							<div class="systemCodePC-add-code-table-li">
								<div class="systemCodePC-add-code-table-li-name">中文描述</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<input type="text" v-model="chinese" />
								</div>
								<div class="systemCodePC-add-code-table-li-text">*必填*</div>
							</div>
							<div class="systemCodePC-add-code-table-li" v-if="codeIndex!=-1">
								<div class="systemCodePC-add-code-table-li-name">附加值</div>
								<div class="systemCodePC-add-code-table-li-ipt">
									<input type="text" v-model="addedValue" />
								</div>
								<div class="systemCodePC-add-code-table-li-text"></div>
							</div>
						</div>
						<div class="systemCodePC-add-code-btn">
							<el-button type="warning" @click="cancelType">取消</el-button>
							<el-button type="primary" @click="preservationType">保存</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pertb005List:this.$store.state.uobj.pertb005,//登陆缓存--用户信息
				typeList: '',
				codeIndex: -1, //类型切换
				value: '',
				moList: '', //默认列表
				systemCodePCAddCode: false,
				systemCodePCUpCode: false,
				// 默认--代码类型
				// 接口字段
				SETTB205CD01: '', //一级企业代码--代码类型
				SETTB205ID:'',//所属代码类型ID
				code: 0, //校验代码类型的判断
				codeNameAdd: 0, //校验中文描述的判断--新增
				codeModifyNameAdd:0,//校验中文描述的判断--修改
				// 新增
				typeAddList: '', //所属类型
				codeTypeAdd: '', //新增--代码类型
				chineseAdd: '', //新增--中文描述
				codeAdd: '', //代码值
				addedValueAdd:'',//附加值
				optionOne: '选项1', // 新增点击所属类型列表
				pageMo:1,//默认列表页码
				limitMo:10,//每页的条数
				pagingPageMo:0,//分页--数据列表共有的条数

				// 修改
				codeTypeValue: '', //修改--代码类型
				codeValue: '', //修改--代码值
				codeValue2:'',//修改--点击所属类型列表--代码值变换判断
				chinese: '', //修改--中文描述
				moListIndex:0,//修改列名称--判断当前点击的列的中文描述和修改的是否一样--默认
				leftTypeListIndex:0,//修改列名称--判断当前点击的列的中文描述和修改的是否一样--左侧列表

				// 左侧--系统代码值
				// 列表
				leftTypeList: '', //点击左侧类型切换列表
				addedValue: '', //修改--附加值
				codeID: '', //代码值id
				pageLeft:1,//点击左侧列表--中间数据列表页码
				limitLeft:10,//每页的条数
				pagingPageLeft:0,//分页--数据列表共有的条数
				currentPage: 1,
				solelist:[],
				// 历史缓存
				currentUrl:this.$route.path,
				historyInfo:''
			}
		},
		created(){
			this.solelist=this.$baseAPI.querSoleList(this.$store.state.solelist,this.$route.path);
			
			// 赋值，缓存销毁
			this.historyInfo=JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if(this.historyInfo!=null&&this.historyInfo!=''){
				this.init()
			}
		},
		watch: {
			// codeIndex: function() {
			// 	var SHover = this.$refs.selectHover;
			// 	if (SHover != undefined) {
			// 		// SHover.$el.className='el-select-dropdown__item'
			// 		SHover[this.codeIndex].$el.className = 'el-select-dropdown__item selected selectHovers'
			// 	}
			// 	// ;
			// 	this.value = this.typeList[this.codeIndex]['value'];
			// },
			// 代码类型
			codeTypeAdd: function(val) {
				this.Inspection(val)
			},
			// 代码值
			codeAdd: function(val) {
				this.InspectionLeft(val)
			},
			// 新增--中文描述
			chineseAdd: function(val) {
				this.InspectionNameAdd(val)
			},
			// 修改--中文描述
			chinese: function(val) {
				this.InspectionModularName(val)
			},
		},
		mounted() {
			this.codeList();
			this.pageList();

		},
		// 存储数据
		beforeDestroy() {
			var obj={
				// codeIndex:this.codeIndex,//类型切换
				currentPage:this.currentPage,//当前页数
				pageMo:this.pageMo,//页码--默认
				limitMo:this.limitMo,//每页条数--默认
				pageLeft:this.pageLeft,//页码--左侧列表
				limitLeft:this.limitLeft//每页条数--左侧列表
			}
			sessionStorage.setItem(this.currentUrl,JSON.stringify(obj))
		},
		methods: {
			//初始化数据
			init(){
				// this.codeIndex=this.historyInfo.codeIndex
				this.currentPage=this.historyInfo.currentPage
				this.pageMo=this.historyInfo.pageMo
				this.limitMo=this.historyInfo.limitMo
				this.pageLeft=this.historyInfo.pageLeft
				this.limitLeft=this.historyInfo.limitLeft
				// console.log(this.codeIndex)
			},
			// 点击左侧代码类型---系统代码值
			// 禁用
			disableClick(index) {
				var SETTB206ID = this.leftTypeList[index]['SETTB206ID']; //代码值id
				var SETTB205ID = this.leftTypeList[index]['SETTB205ID'];//代码类型
				var SETTB206CA02 = this.leftTypeList[index]['SETTB206CA02']; //状态--1启用，0禁用
				var SETTB206CA00 = this.leftTypeList[index]['SETTB206CA00']; //代码值
				var state;
				if(SETTB206CA02==0){
					state=1;
				}else if(SETTB206CA02==1){
					state=0;
				}
				var postData = {
					SETTB206CD01:this.pertb005List['pertb005cd01'],//一级企业代码
					SETTB206ID: SETTB206ID, //代码值id
					SETTB205ID:SETTB205ID,//代码类型
					SETTB206CA02: state ,//状态
					SETTB206CA00:SETTB206CA00//代码值
				}
				// console.log(SETTB206CA02);
				var url = "/set/settb206/update";
				if (SETTB206CA02 == 1) {
					this.$confirm('此操作将禁用该条数据, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.axios.post(url, postData).then(res => {
							// console.log(res)
							if (res.data.code == 200) {
								this.leftTypeLists(this.codeIndex);
								this.$message({
									type: 'success',
									message: '禁用成功'
								});
							} else {
								this.$message({
									message: res.data.message,
									type: 'error'
								});
							}
						})
					})
				}else if (SETTB206CA02 == 0) {
					this.$confirm('此操作将启用该条数据, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.axios.post(url, postData).then(res => {
							// console.log(res)
							if (res.data.code == 200) {
								this.leftTypeLists(this.codeIndex);
								this.$message({
									type: 'success',
									message: '启用成功'
								});
							} else {
								this.$message({
									message: res.data.message,
									type: 'error'
								});
							}
						})
					})
				}
			},
			// 列表
			leftTypeLists(index) {
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var SETTB205ID = this.typeList[index]['SETTB205ID']; 
				var postData = {
					// SETTB206CD01: '410100',
					SETTB206CD01: this.pertb005List['pertb005cd01'],//一级企业代码
					SETTB205ID: SETTB205ID, //代码类型
					page: this.pageLeft,
					limit: this.limitLeft
				}
				var url = "/set/settb206/selectPageList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.leftTypeList = res.data.data;
						this.pagingPageLeft=res.data.count;
						// console.log(this.pagingPageLeft)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 检验代码值--点击左侧类型列表(系统代码值)
			InspectionLeft(val) {
				var postData = {
					SETTB206CA00: val,
					// SETTB206CD01: '410100'
					SETTB206CD01: this.pertb005List['pertb005cd01'],//一级企业代码
				}
				var url = "/set/settb206/checkSettb206ca00";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 500) {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
						this.code = 1;
					} else {
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'success'
						// });
						this.code = 0;
					}
				}).catch(()=>{
					
				})
			},
			// 检验中文描述--新增
			InspectionNameAdd(val) {
				if(val==='') return 
				if(this.codeIndex==-1){
					var postData = {
						SETTB205CA00: val,
						CD01: this.pertb005List['pertb005cd01'],//一级企业代码
					}
					var url = "/set/settb205/checkSETTB205CA00";
				}else{
					var postData = {
						SETTB206CA01: val,
						SETTB206CD01: this.pertb005List['pertb005cd01'],//一级企业代码
					}
					var url = "/set/settb206/checkSettb206ca01";
				}
				// var loading=this.$loading({
				// 	lock: true,
				// 	text: '请求中...',
				// 	spinner: 'el-icon-loading',
				// 	background: 'rgba(0, 0, 0, 0.5)'
				// });
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 500) {
						// this.$message({
						// 	message: "新增成功",
						// 	type: 'error'
						// });
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.codeNameAdd = 1;
					} else {
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'success'
						// });
						this.codeNameAdd = 0;
					}
					// setTimeout(()=>{
					// 	loading.close()
					// },300)
				}).catch(()=>{
					// loading.close()
				})
			},
			// 新增保存接口--左侧类型列表(系统代码值)
			postAddLeft() {
				// codeAdd代码值codeTypeAdd代码类型chineseAdd中文描述addedValueAdd附加值
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB205ID: this.SETTB205ID, //所属代码类型id
					SETTB206CA00:this.codeAdd, //代码值
					SETTB206CA01: this.chineseAdd, //中文描述
					SETTB206CA03:this.addedValueAdd, //附加值
					// SETTB206CD01: '410100',//一级企业代码
					SETTB206CD01: this.pertb005List['pertb005cd01'],//一级企业代码
				}
				var url = "/set/settb206/insert";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.systemCodePCAddCode = false;
						this.leftTypeLists(this.codeIndex);
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 页面默认---代码类型
			// 新增保存
			preservationAdd() {
				if (this.code != 1 && this.codeNameAdd!=1) {
					// codeAdd代码值codeTypeAdd代码类型chineseAdd中文描述addedValueAdd附加值
					if (this.optionOne != '选项1') {
						if (this.codeAdd == '') {
							this.$message({
								message: '代码值不能为空',
								type: 'error'
							});
						}else if(this.codeAdd.length<4){
						 	this.$message({
						 		message: '代码值请输入4位数字',
						 		type: 'error'
						 	});
						 }else if (this.chineseAdd == '') {
							this.$message({
								message: '中文描述不能为空',
								type: 'error'
							});
						} else {
							this.postAddLeft();
						}
					} else if (this.optionOne == '选项1') {
						if (this.codeTypeAdd == '') {
							this.$message({
								message: '代码类型不能为空',
								type: 'error'
							});
						} else if (this.chineseAdd == '') {
							this.$message({
								message: '中文描述不能为空',
								type: 'error'
							});
						} else {
							this.postAdd();
						}
					}
				} else 	if (this.code == 1) {
					this.$message({
						message: '代码类型重复',
						type: 'error'
					});
				}else if (this.codeNameAdd==1){
					this.$message({
						message: '中文描述重复',
						type: 'error'
					});
				}
			},
			postAdd() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// this.SETTB205CD01 = this.moList[index]['SETTB205CD01']; //一级企业代码
				// this.SETTB205CD01 = this.moList[index]['SETTB205ID']
				var postData = {
					// SETTB205CD01: '410100',
					SETTB205CD01:this.pertb005List['pertb005cd01'],//一级企业代码
					SETTB205ID: this.codeTypeAdd, //代码类型
					SETTB205CA00: this.chineseAdd, //中文描述
					// SETTB205CD01: this.SETTB205CD01 //一级企业代码
				}
				var url = "/set/settb205/insert";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.systemCodePCAddCode = false;
						this.pageList();
						this.codeList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 检验代码类型--默认(代码类型)
			Inspection(val) {
				// console.log(val)
				var postData = {
					SETTB205ID: val,
					// CD01: '410100'
					CD01: this.pertb005List['pertb005cd01'],//一级企业代码
				}
				var url = "/set/settb205/checkSETTB205ID";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 500) {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
						this.code = 1;
					} else {
						// this.$message({
						// 	message: res.data.message,
						// 	type: 'success'
						// });
						this.code = 0;
					}
				})
			},
			// 新增点击所属类型列表
			changAdd(e) {
				this.optionOne = e;
				if(this.codeIndex==-1){
					this.codeAdd = this.typeAddList[e.slice(2) - 1]['code'];
				}else{
					this.codeAdd = this.typeAddList[e.slice(2)-1]['code'];
				}
				this.codeTypeAdd='';
				this.chineseAdd='';
				this.SETTB205ID=this.typeAddList[e.slice(2) - 1]['code'];
				// console.log(this.SETTB205ID);
			},
			// 新增取消--X
			XAdd() {
				if(this.codeIndex==-1){
					this.optionOne = '选项1';
				}else{
					this.optionOne = '选项0';
				}
			},
			// 新增取消
			cancelAdd() {
				this.systemCodePCAddCode = false;
				if(this.codeIndex==-1){
					this.optionOne = '选项1';
				}else{
					this.optionOne = '选项0';
				}
				
			},
			// 新增
			newlyAdd() {
				// debugger
				this.systemCodePCAddCode = true;
				this.chineseAdd='';
				this.addedValueAdd='';
				this.codeTypeAdd='';
				var List = [{
					value: '选项1',
					label: '顶级代码',
					code: '推荐:01'
				}];
				var newarr = [];
				var arr = [...List, ...this.typeList];
				for (var i = 0; i < arr.length; i++) {
					if (i == 0) {
						newarr.push(arr[0])
					} else {
						newarr.push({
							'value': '选项' + (i + 1),
							"label": arr[i]['SETTB205CA00'],
							'code': arr[i]['SETTB205ID']
						})
					}
				}
				this.typeAddList = newarr;
				if(this.codeIndex==-1){
					this.value = this.typeAddList[0]['value'];
				}else{
					this.value = this.typeAddList[this.codeIndex+1]['value'];
					this.codeAdd = this.typeAddList[this.codeIndex+1]['code'];
					this.SETTB205ID=this.typeAddList[this.codeIndex+1]['code'];
					// console.log(this.SETTB205ID);
					this.InspectionLeft(this.codeAdd)
				}
				

			},
			// 检验中文描述--修改
			InspectionModularName(val){
				if(this.codeIndex==-1){
					var postData = {
						SETTB205CA00: val,
						CD01: this.pertb005List['pertb005cd01'],//一级企业代码
					}
					var url = "/set/settb205/checkSETTB205CA00";
				}else{
					var postData = {
						SETTB206CA01: val,
						SETTB206CD01: this.pertb005List['pertb005cd01'],//一级企业代码
					}
					var url = "/set/settb206/checkSettb206ca01";
				}
				var SETTB205CA00;
				if(this.codeIndex==-1){
					SETTB205CA00=this.moList[this.moListIndex]['SETTB205CA00']
				}else{
					SETTB205CA00=this.leftTypeList[this.leftTypeListIndex]['SETTB206CA01']
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.codeModifyNameAdd = 0;
					} else {
						this.codeModifyNameAdd = 0;
						if(val!=SETTB205CA00){
						this.codeModifyNameAdd = 1;
						this.$message({
							message: res.data.message,
							type: 'error'
						});
						}else if(val==SETTB205CA00){
							this.codeModifyNameAdd = 0;
						}
					}
				})
			},
			// 保存修改
			preservationType() {
				// console.log(this.codeModifyNameAdd)
				if (this.codeModifyNameAdd!=1) {
					if (this.codeIndex != -1) {
						if (this.chinese == '') {
							this.$message({
								message: '中文描述不能为空',
								type: 'error'
							});
						} else {
							this.modifyLeftPost();
						}
					} else if (this.codeIndex == -1) {
						if (this.chinese == '') {
							this.$message({
								message: '中文描述不能为空',
								type: 'error'
							});
						} else {
							this.modifyMoPost();
							this.codeList();
						}
					}
				} else if (this.codeModifyNameAdd==1){
					this.$message({
						message: '中文描述重复',
						type: 'error'
					});
				}
			},
			// 修改请求--默认
			modifyMoPost(){
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// SETTB205CD01:'410100',
					SETTB205CD01:this.pertb005List['pertb005cd01'],//一级企业代码
					SETTB205ID: this.codeTypeValue,
					SETTB205CA00: this.chinese,
					// SETTB205CD01: this.SETTB205CD01
				}
				var url = "/set/settb205/update";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.systemCodePCUpCode = false;
						this.pageList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 修改请求--左侧列表
			modifyLeftPost(){
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var SETTB205ID=this.typeList[this.codeIndex]['SETTB205ID']
				// console.log(SETTB205ID);
				var postData = {
					SETTB206CD01:this.pertb005List['pertb005cd01'],//一级企业代码
					SETTB206ID: this.codeID, //代码值id
					SETTB205ID:SETTB205ID,//代码类型
					SETTB206CA00: this.codeValue, //代码值
					SETTB206CA01: this.chinese, //中文描述
					SETTB206CA03: this.addedValue //附加值
				}
				var url = "/set/settb206/update";
				if (this.chinese != '') {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.systemCodePCUpCode = false;
							this.leftTypeLists(this.codeIndex);
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						setTimeout(()=>{
							loading.close()
						},300)
					}).catch(()=>{
						loading.close()
					})
				}
			},
			// 取消保存
			cancelType() {
				this.systemCodePCUpCode = false;
			},
			// 修改
			modify(index) {
				this.systemCodePCUpCode = true;
				if (this.codeIndex == -1) {
					this.moListIndex=index;
					this.codeTypeValue = this.moList[index]['SETTB205ID']; //代码类型
					this.chinese = this.moList[index]['SETTB205CA00']; //中文描述
					this.SETTB205CD01 = this.moList[index]['SETTB205CD01']; //一级企业代码
				} else {
					this.leftTypeListIndex=index;
					var List = [{
						value: '',
						label: '',
						code: ''
					}];
					for (var i = 0; i < this.typeList.length; i++) {
						List[i] = {
							'value': '选项' + (i + 1),
							"label": this.typeList[i]['SETTB205CA00'],
							'code': this.typeList[i]['SETTB205ID'],
							// 'code': this.typeList[i]['SETTB206CA00']
						}
					}
					this.typeAddList = List;
					this.value = this.typeAddList[this.codeIndex]['value'];
					// this.codeAdd = this.typeAddList[this.codeIndex]['value'];
					this.postModify(index);
				}
			},
			postModify(index){
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(index);
				// console.log(this.leftTypeList)
				var SETTB206ID = this.leftTypeList[index]['SETTB206ID']; //一级企业代码
				var postData = {
					SETTB206ID: SETTB206ID,
				}
				var url = "/set/settb206/toUpdate";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.codeValue = res.data.data['SETTB206CA00'];
						this.codeValue2=res.data.data['SETTB206CA00'];
						this.chinese = res.data.data['SETTB206CA01'];
						this.addedValue = res.data.data['SETTB206CA03'];
						this.codeID = res.data.data['SETTB206ID'];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 类型
			codeList() {
				var postData = {
					// SETTB205CD01: '410100'
					SETTB205CD01:this.pertb005List['pertb005cd01'],//一级企业代码
				}
				var url = "/set/settb205/queryCodeTypeList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.typeList = res.data.data;
					} else {
						this.typeList=[]
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			// 列表
			pageList() {
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// SETTB205CD01: '410100',
					SETTB205CD01:this.pertb005List['pertb005cd01'],//一级企业代码
					page: this.pageMo,
					limit: this.limitMo
				}
				var url = "/set/settb205/selectPageList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.moList = res.data.data;
						this.pagingPageMo=res.data.count;
						// console.log(this.pagingPageMo)
					} else {
						this.moList = [];
						this.pagingPageMo=0;
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			// 类型切换
			typeClick(index) {
				this.codeIndex = index;
				// this.value = this.typeList[index]['label'];
				this.leftTypeLists(this.codeIndex);
				this.optionOne='选项'+(this.codeIndex+2);
			},
			// 下拉列表--点击选项
			selectChange(e) {
				if(this.codeIndex != -1){
					this.codeValue='';
					var codeAdd1=this.typeList[e.slice(2)-1]['SETTB205ID'];
					var codeAdd2=this.codeValue2;
					this.codeValue=codeAdd1+codeAdd2;
				}
			
				// this.value=e;
				// this.optionOne = e;
				// this.codeValue = this.typeAddList[e.slice(2) - 1]['code'];
			},
			// 下拉列表--获取焦点
			elSelect() {
				// this.value=this.typeList[this.codeIndex]['value'];
				// this.value=val;
				var SHover = this.$refs.selectHover;
				// SHover[this.codeIndex].$el.className='hover'

			},
			// 上一页
			// prevPage(){
			// 	if(this.codeIndex==-1){
			// 		this.pageMo--;
			// 		this.pageList();
			// 	}else{
			// 		this.pageLeft--;
			// 		this.leftTypeLists(this.codeIndex);
			// 	}
			// },
			// // 下一页
			// nextPage(){
			// 	if(this.codeIndex==-1){
			// 		this.pageMo++;
			// 		this.pageList();
			// 	}else{
			// 		this.pageLeft++;
			// 		this.leftTypeLists(this.codeIndex);
			// 	}
			// },
			// 每页显示条数
			handleSizeChange(val) {		
				if(this.codeIndex==-1){
					this.limitMo=val;
					this.pageList();
				}else{
					this.limitLeft=val;
					this.leftTypeLists(this.codeIndex);
				}
				// console.log(`每页 ${val} 条`);
			},
			// 点击页码
			handleCurrentChange(val) {
				if(this.codeIndex==-1){
					this.pageMo=val;
					this.pageList();
				}else{
					this.pageLeft=val;
					this.leftTypeLists(this.codeIndex);
				}
				// console.log(`当前页: ${val}`);
			}
		}
	}
</script>

<style scoped>
	.selectHovers {
		background-color: #F5F7FA;
	}

	.systemCode .el-select-dropdown__item.hover {
		background-color: #fff !important;
	}

	.systemCodePC {
		display: flex;
		font-size: 16px;
		color: #333;
		padding: 30px 40px 20px 20px;
	}

	.systemCodePC-side {
		flex: .4;
	}

	.systemCodePC-side-nav-item {
		height: 40px;
		line-height: 40px;
		padding-left: 20px;
	}

	.systemCodeActive {
		background-color: #1AA0FF !important;
		color: #FFF;
	}

	.systemCodePC-side-nav-item i {
		margin-right: 5px;
	}

	.systemCodePC-side-nav-item:hover {
		background-color: #ccc;
	}

	.systemCodePC-side-nav-item:focus {
		background-color: #ccc;
	}

	.systemCodePC-content {
		flex: 2;
		padding-left: 20px;
	}
.systemCodePC-content-table{
		margin-top: 20px;
	}
	.systemCodePC-content-table-li {
		display: flex;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #333;
		border-bottom: 1px solid #CDCDCD;
	}
	
	.systemCodePC-content-table-li:first-child{
		font-weight: bold;
		font-size: 16px;
		height: 48px;
		line-height: 48px;
	}

	.systemCodePC-content-table-li>div {
		flex: 1;
		text-align: center;
	}

	.systemCodePC-add-code {
		padding: 0 20px;
	}

	.systemCodePC-add-code-table-li-ipt input {
		vertical-align: top;
	}

	.systemCodePC-pagesize {
		text-align: right;
		margin-top: 20px;
	}
</style>
<style>
.system-settings-system-code-dialog {
	border: 1px solid rgba(207, 225, 245, 0.95);
	border-radius: 18px;
	background: #f8fbff;
	box-shadow: 0 24px 70px rgba(18, 52, 77, 0.22);
	overflow: hidden;
}

.system-settings-system-code-dialog .el-dialog__header {
	position: relative;
	height: auto;
	line-height: normal;
	padding: 18px 54px 16px 24px;
	vertical-align: middle;
	background: linear-gradient(135deg, #f5fbff 0%, #ffffff 48%, #eef8ff 100%);
	border-bottom: 1px solid rgba(219, 233, 247, 0.95);
	color: #17324d;
}

.system-settings-system-code-dialog .el-dialog__header::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	width: 5px;
	height: 100%;
	background: linear-gradient(180deg, #199fff 0%, #5ac8fa 100%);
}

.system-settings-system-code-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #17324d !important;
	letter-spacing: .2px;
}

.system-settings-system-code-dialog .el-dialog__headerbtn {
	top: 13px;
	right: 18px;
	border-radius: 50%;
	background: rgba(25, 159, 255, 0.08);
	transition: background .2s ease, transform .2s ease;
}

.system-settings-system-code-dialog .el-dialog__headerbtn:hover {
	background: rgba(25, 159, 255, 0.16);
	transform: rotate(90deg);
}

.system-settings-system-code-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}

.system-settings-system-code-dialog .el-dialog__body {
	max-height: calc(90vh - 130px);
	padding: 22px 24px 24px;
	background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
	color: #31445a;
	overflow-y: auto;
}

.system-settings-system-code-dialog .systemCodePC-add-code {
	padding: 0;
}

.system-settings-system-code-dialog .systemCodePC-add-code-table {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.system-settings-system-code-dialog .systemCodePC-add-code-table-li {
	display: grid;
	grid-template-columns: 120px minmax(0, 1fr) 64px;
	align-items: center;
	gap: 10px;
	min-height: 46px;
	padding: 10px 12px;
	border: 1px solid rgba(220, 232, 245, 0.9);
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.88);
	box-shadow: 0 6px 16px rgba(23, 77, 124, 0.05);
	box-sizing: border-box;
}

.system-settings-system-code-dialog .systemCodePC-add-code-table-li-name {
	color: #203a56;
	font-size: 14px;
	font-weight: 600;
	text-align: right;
}

.system-settings-system-code-dialog .systemCodePC-add-code-table-li-ipt {
	min-width: 0;
}

.system-settings-system-code-dialog .systemCodePC-add-code-table-li-ipt input,
.system-settings-system-code-dialog .systemCodePC-add-code-table-li-ipt .el-input__inner {
	width: 100%;
	height: 36px;
	line-height: 36px;
	padding: 0 12px;
	border: 1px solid #d7e5f3;
	border-radius: 9px;
	background: #fff;
	color: #1f3449;
	box-sizing: border-box;
	transition: border-color .18s ease, box-shadow .18s ease;
}

.system-settings-system-code-dialog .systemCodePC-add-code-table-li-ipt input:focus,
.system-settings-system-code-dialog .systemCodePC-add-code-table-li-ipt .el-input__inner:focus {
	border-color: #199fff;
	box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
	outline: none;
}

.system-settings-system-code-dialog .systemCodePC-add-code-table-li-ipt input[readonly] {
	background: #f3f7fb;
	color: #7a8ca0;
}

.system-settings-system-code-dialog .systemCodePC-add-code-table-li-text {
	color: #ff6b6b;
	font-size: 12px;
	white-space: nowrap;
}

.system-settings-system-code-dialog .el-select,
.system-settings-system-code-dialog .systemCode_beloneStyle {
	width: 100%;
}

.system-settings-system-code-dialog .systemCodePC-add-code-btn {
	display: flex;
	justify-content: space-between;
	gap: 16px;
	margin: 22px 0 0;
	padding-top: 18px;
	border-top: 1px solid rgba(223, 235, 247, 0.9);
}

.system-settings-system-code-dialog .systemCodePC-add-code-btn .el-button {
	min-width: 96px;
	border-radius: 9px;
	margin-left: 0;
}

.system-settings-system-code-dialog .systemCodePC-add-code-btn .el-button--warning {
	order: 1;
}

.system-settings-system-code-dialog .systemCodePC-add-code-btn .el-button--primary {
	order: 2;
}

@media screen and (max-width: 768px) {
	.system-settings-system-code-dialog {
		width: calc(100vw - 24px) !important;
	}

	.system-settings-system-code-dialog .el-dialog__body {
		padding: 18px 16px 20px;
	}

	.system-settings-system-code-dialog .systemCodePC-add-code-table-li {
		grid-template-columns: 1fr;
		gap: 8px;
	}

	.system-settings-system-code-dialog .systemCodePC-add-code-table-li-name {
		text-align: left;
	}
}
</style>
